/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as marietta from '../../..';

/**
 * ラインスナップを扱うクラス
 */
export default class LineSnap {
    type: string;

    a: number;

    b: number;

    c: number;

    radius: number;

    priority: number;

    related: any;

    itemType: string;

    /**
    * コンストラクタ
    */
    constructor(a: number, b: number, c: number, radius: number, priority: number, related: any, itemType: string = 'line') {
      this.type = 'line';
      this.a = a;
      this.b = b;
      this.c = c;
      this.radius = radius;
      this.priority = priority;
      this.related = related;
      this.itemType = itemType;
    }

    /**
     * 最も近いポイントを取得します
     * @param x
     * @param y
     * @returns
     */
    nearestPoint(x: number, y: number) { // returns nearest point
      return {
        ...marietta.webcad.WebCADGlobal.snapManager.closestPointFromLine(this.a, this.b, this.c, x, y),
        distance: marietta.webcad.WebCADGlobal.snapManager.distancePointFromLine(this.a, this.b, this.c, x, y),
      };
    }

    /**
     * チェックポイントが最も近いポイントです
     * @param _x
     * @param y
     * @param distance
     * @returns boolean
     */
    isNear = (_x: number, _y: number, _distance: number) => true;
}
